
export default {
    data() {
        return {

        }
    },

    created() {

    },

    methods: {
        openPage() {
            if(this.type === 0) {
                window.open(this._link + 'news/detail?id=' + this.data.id)
            }else if(this.type === 1) {
                window.open(this._link + 'topic/detail?id=' + this.data.id)
            }else {
                this.data.page = 1;
                console.log(this.data);
                let type = this.data.type === 2 ? 1 : 2;
                window.open(this._link + 'active/detail?id=' + this.data.id + '&type=' + type)
            }
        }
    }
}
